/**
 * tenantClient — identificação do cliente/tenant da instância no front.
 *
 * Extraído de App.tsx (loadClientRoutes) para reuso: gating de superfícies
 * por tenant (ex.: rotas /sac/* que consomem o Service Desk do HUB via proxy
 * ficam restritas ao tenant copa até a migração M2 — TMF9-58844).
 *
 * Resolução (mesma ordem do overlay de rotas por cliente):
 *   1. VITE_CLIENT_CODE (build-time, instâncias dedicadas)
 *   2. Subdomínio do hostname (ex.: copa.trademarketingforce.com → "copa")
 *
 * @since 2026-07-10
 * @issue TMF9-58844
 */

/** Subdomínios de clientes conhecidos (espelha o overlay src/clients/*). */
const KNOWN_CLIENTS = [
  'copa', 'apex', 'suvinil', 's2holding', 'drogacenter',
  'italac', 'pearson', 'site', 'supley', 'demo',
] as const

/**
 * Detecta o código do cliente a partir do subdomínio do hostname.
 * localhost/*.local/*.test não identificam cliente (dev sem overlay).
 */
export function detectClientFromDomain(): string | undefined {
  const hostname = window.location.hostname
  if (!hostname || hostname === 'localhost' || hostname.endsWith('.local') || hostname.endsWith('.test')) {
    return undefined
  }
  const subdomain = hostname.split('.')[0]
  return (KNOWN_CLIENTS as readonly string[]).includes(subdomain) ? subdomain : undefined
}

/** Código do cliente da instância (VITE_CLIENT_CODE > subdomínio), se houver. */
export function getTenantClientCode(): string | undefined {
  return import.meta.env.VITE_CLIENT_CODE || detectClientFromDomain()
}

/**
 * Tenant COPA — seus tickets de Service Desk vivem no Hub (tmf-management),
 * acessados via proxy `/api/v1/hub/proxy/service/tickets*`. Enquanto a migração
 * M2 (Hub → motor SD local) não é feita, o Copa consome o Service Desk pelo
 * `serviceDeskClient` (proxy Hub), não pelo `tmf9SDApiClient` (motor local, vazio
 * para o Copa). Demais tenants usam o motor local. [TMF9-58844]
 */
export function isCopaTenant(): boolean {
  return getTenantClientCode() === 'copa'
}
